<template>
  <div v-if="showTip">
    <el-dialog :title="title" :visible.sync="showTip" :before-close="closeFn" append-to-body>
      <div class="clock_height">
        <div class="all_content">
          <!-- <pdf
            ref="pdf"
            :src="src"
            :page="page"
            :rotate="rotate"
            @num-pages="numPages = $event"
          ></pdf> -->
          <iframe
            ref="pdf"
            style="width: 100%; height: 800px;"
            :src="'/zfcg/static/plugin/pdfjs/web/viewer.html?file=' + encodeURI(src)"
          ></iframe>
        </div>
      </div>
      <span slot="footer" class="dialog-footer" v-if="downloadText">
          <el-button type="primary" @click="downloadFile">{{downloadText}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import pdf from 'vue-pdf-cs';
export default {
  name:'onlyPdf',
  components: {
    pdf,
  },
  props:{
    title:{
      default:'',
      type:[String]
    },
    showTip:{
      default:true,
      type:[Boolean]
    },
    src:{
      default:'',
      type:[String]
    },
    downloadText:{
      type:[String],
      default:''
    }
  },
  data() {
    return {
      PDF_URL:'',
      page:1,
      rotate:0,
      numPages:0,
      close:true,

    };
  },
  methods: {
    closeFn(){
      this.$emit('showTipFn',false)
    },
    downloadFile(){
      window.location.href = this.src;
    }
  },
  mounted() {

  },
  // computed:{
  //   'showTip':function(val){
  //       // this.$emit('showTipFn',false)
  //   }
  // }
};
</script>



// WEBPACK FOOTER //
// src/components/dialogOnlyPdf.vue